import styled from "styled-components";

export const FormButtonsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: ${({ theme }) => theme.spacing(2)};
`;
